<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form #auroraSubmitForm="ngForm"
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="SIC">SIC</label>
              <!--TODO-->
              <!-- TODO CHange -->
              <input
                myFocus
                type="text"
                name="SIC"
                [(ngModel)]="dsCollection.criteria.Code_Desc"
                ngControl="Code Description"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-8">
            <aurora-button
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              variant="primary"
              (click)="auroraSubmitForm.onSubmit($event)"
            >
              Search
            </aurora-button>
            <aurora-button
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="button"
              (click)="dsCollection.criteria.Code_Desc = ''; model.dirty = true"
              variant="secondary"
            >
              Reset
            </aurora-button>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #codeSetFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header">
            <tr
              *ngIf="
                dsCollection.objectNode?.CodeItems?.CodeItem && dsCollection.objectNode?.CodeItems?.CodeItem.length > 0
              "
            >
              <th>Code</th>
              <th>Code Description</th>
            </tr>
            <tr
              *ngFor="
                let codeItem of dsCollection.objectNode?.CodeItems?.CodeItem
                  | epFilter : codeSetFilter?.filter : codeSetFilter?.filter?.filterText
              "
              (click)="app.getSelectedText() && select(codeItem)"
            >
              <td>
                {{ codeItem.Code }}
              </td>
              <td>
                {{ codeItem.Code_Desc }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(
                  dsCollection.objectNode?.CodeItems?.CodeItem &&
                  dsCollection.objectNode?.CodeItems?.CodeItem.length > 0
                ) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Codes</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
